<template>
    <div class="qa-list container">
      <div
        v-for="(item, index) in questions"
        :key="index"
        class="qa"
      >
        <div class="question flex__between pointer" @click="toggle(index)">
          <p class="text__bold">{{ item.question }}</p>
          <div class="icon">
            <font-awesome-icon :icon="toggledIndex === index ? 'caret-up' : 'caret-down'" size="1x" class="ml-10" />
          </div>
        </div>
        <div class="answer" :class="{ 'answer-slide': toggledIndex === index }">
          <div>{{ item.answer }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        toggledIndex: null,
        questions: [
          {
            question: "What is a service transfer?",
            answer:
              "A service transfer means the responsibility of managing the loan's day-to-day operations, such as collecting payments, handling escrow accounts, and responding to inquiries about your loan transfers from one company to another.",
          },
          {
            question: "Why was my loan transferred?",
            answer:
              "Loan transfers are common in the mortgage industry and typically occur for business reasons. The terms of your loan do not change as a result of the transfer.",
          },
          {
            question: "How do I make payments after the transfer?",
            answer:
              "You will receive instructions from the new servicer on how to make payments. Be sure to follow their guidance to avoid any issues.",
          },
          {
            question: "Why did my loan transfer?",
            answer: 
            "Service transfers are quite common in the mortgage industry as companies are constantly balancing their portfolio and makeup of loan types. Receiving a service transfer notice has nothing to do with you as an individual or your payment history."
          },
          {
            question: "I'm on a recurring auto-draft (ACH) with Flat Branch, what will happen?",
            answer: 
            "We will continue to draft payments as you specified until the transfer date. Because auto-draft is non-transferable, you will need to contact your new loan servicer to re-establish drafting after the transfer date."
          },
          {
            question: "I'm on recurring bill-pay with my bank, what will happen?",
            answer: 
            "Please contact your bank to update the payee to your new loan servicer. You can usually accomplish this by logging in to your online banking account. Your new loan servicer’s contact information and payment address can be found in your ‘Notice of Servicing Transfer’ letter."
          },
          {
            question: "What if I sent my payment to Flat Branch and it’s owed to my new servicer?",
            answer: 
            "For 60 days after the transfer date, we will forward payments we receive to your new servicer. During the same 60-day period you are protected from late fees and late credit reporting with your new loan servicer. Once the 60-day period expires, any payments we receive may be returned to you, please be sure to update your payment methods to prevent this from occurring."
          },
          {
            question: "Will I still have access to my online account?",
            answer:
            "There will be a short blackout period from the night of June 30th to July 1st, after that you will have limited access to your online account. Please contact your new servicer to inquire about setting up an online account on their website."
          },
          {
            question: "Can I stop my loan from transferring?",
            answer: 
            "Transferring loans are selected by similar loan attributes and transferred as a group. Unfortunately, we are unable to remove a loan upon request."
          },
          {
            question: "How will I be notified of a service transfer?",
            answer: 
            "At least 15 calendar days before the service transfer, Flat Branch will mail you a Notice of Servicing Transfer letter with the name of your new loan servicer and their contact information. Additionally, within 15 days after your transfer date your new loan servicer will mail you a letter confirming the transfer."
          },
          {
            question: "Can my loan transfer more than once?",
            answer:
            "Yes, it is possible that your loan may be transferred more than once. We are unable to predict if a loan will transfer again in the future."
          },
          {
            question: "What will change?",
            answer:
            "During a service transfer the only thing that will change is who you make your payments to and who you contact for inquiries. Nothing about the loan terms and conditions will change."
          },
          {
            question: "Will I receive a year-end 1098 statement from Flat Branch?",
            answer: "Yes, Flat Branch will mail a year-end statement to you no later than January 31, 2026. If your mailing address changes prior to then, please log in to your Flat Branch Servicing Digital account and click ‘Account Management’ to update your mailing address. Your new loan servicer will mail you a separate year-end statement for interest paid to them."
          },
          {
            question: "Do I need to notify my homeowners insurance company?",
            answer: "Flat Branch will notify your insurance carrier of the change. However, if you receive an insurance bill or other correspondence that still has Flat Branch listed as the mortgagee, please notify them to update their records."
          },
          {
            question: "I'm in the middle of an insurance claim, what will happen?",
            answer: "We will continue to work with you on your active insurance claim through the transfer date. If you have funds remaining on a monitored claim, they will be transferred to your new loan servicer to continue the process."
          },
          {
            question: "I applied for hardship assistance, what will happen to my application?",
            answer: "Flat Branch will continue to accept and process applications through the transfer date. On the day of transfer, we will send all documents and loan status to your new loan servicer; they will continue the review from that point forward. If we receive additional documents after the transfer date, we will forward them to your new loan servicer."
          },
          {
            question: "I have additional questions, who do I call?",
            answer: "Beginning with the transfer date, Flat Branch will no longer have access to current loan information, so it is best to contact your new loan servicer with questions from that date forward. Flat Branch will forward all historical records such as payment history, notes, and loan documents to your new loan servicer. Please refer to your ‘Notice of Servicing Transfer’ letter for their contact information."
          },
          {
            question: "I called my new loan servicer, and they can’t locate my loan, what do I do?",
            answer: "When a loan transfers it’s common for the new loan servicer to have a small blackout window (usually only a couple of days) while they board your loan information. Inform the representative of your transfer date and they can provide more information on the expected processing time. For a 60-day period after the transfer date you are protected from late fees and late credit reporting with your new loan servicer."
          }
        ],
      };
    },
    methods: {
      toggle(index) {
        this.toggledIndex = this.toggledIndex === index ? null : index;
      },
    },
  };
  </script>
  
  <style lang="scss">
  .qa-list {
    margin: 10px 0;
  }
  .qa {
    margin: 5px 0;
  }
  .answer {
    overflow: hidden;
    @include grid($cols: 1fr, $row-gap: 2px);
    height: auto;
    max-height: 0;
    transition: all 0.35s linear;
  }
  .question {
    background-color: $frost;
    padding: 10px 5px;
    color: $green;
    border: 1px solid $cloud;
    border-radius: 3px;
    .icon {
      color: $black;
    }
    &:hover {
      background-color: lighten($frost, 5%);
    }
  }
  .answer {
    > div,
    > p {
      padding: 20px 15px;
      p {
        margin-bottom: 8px;
      }
      ul {
        padding-left: 15px;
        li {
          margin-bottom: 5px;
        }
      }
    }
    background-color: lighten($cloud, 15%);
    border-radius: 3px;
  }
  .answer-slide {
    max-height: 1000px;
  }
  </style>